const state = {
    map_key: "UKQBZ-T2M36-MHVSA-MM3AN-J7OZ2-AZFK6",
};
// 并导出
export default state;
